import { render } from "./updateModal.vue?vue&type=template&id=c2da5122&scoped=true"
import script from "./updateModal.vue?vue&type=script&lang=js"
export * from "./updateModal.vue?vue&type=script&lang=js"

import "./updateModal.vue?vue&type=style&index=0&id=c2da5122&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c2da5122"],['__file',"src/components/PageLogin/updateModal.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "c2da5122"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('c2da5122', __exports__)) {
    api.reload('c2da5122', __exports__)
  }
  
  module.hot.accept("./updateModal.vue?vue&type=template&id=c2da5122&scoped=true", () => {
    api.rerender('c2da5122', render)
  })

}


export default __exports__